module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAANCAYAAACZ3F9/AAABE0lEQVQokYXSMUuCURTG8Z9aDTVU0NJiQe4OLS5pFNHYN6ghCtIogj5IEUQYDY0OCY0NQpIfoyEiiKBoCyLMhtdXr0p1lsN57v0fnnPPTbSqKX2xghLymMQb6jjBbXwpEYAjKGOjv1MQZeziaygQz7H+BwTbaKKYDOx1odHZ3uvDE2G1g6UYLHbkqQKr96TbjsezUT1VCOHN2Gq+I73Webxk/oKxGeb2eL6O9G4sJlrVVALfA9Pkrphei4C75f7TZhItvPfI49nI2sdDlNMDD/0Sz9jogRZqkb2bTNd274yNeI9LqHXkzD73x36tWQg/QBlbA7MOxhEOkoFQwtk/0CkOIQS/tJeLCp7w2c4V5NrNm/ADxhlFVh1gppMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./app/content/images/suspension-close.png
// module id = xhOQ
// module chunks = 11